import React from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    TextField
} from '@material-ui/core';
import { useAuthDataContext } from '../../components/auth-provider';
import { Alert } from '../../components/MySnackToast';

export const ChangePassword = ({ className, ...rest }: any) => {

    const { changePassword, isLoading, errorMessage, resetErrorMessage } = useAuthDataContext();

    const handleChange = (event: any) => {
        resetErrorMessage && resetErrorMessage();
    };

    const handleSubmit = (ev: any) => {
        ev.preventDefault();

        const { confirm, password } = ev.currentTarget.elements;

        changePassword && changePassword(password.value, confirm.value);
    }

    return (
        <form
            noValidate
            onSubmit={handleSubmit}
        >
            <Card>
                <CardHeader
                    subheader="Alterar senha"
                    title="Senha"
                />
                <Divider />
                <CardContent>
                    <TextField
                        fullWidth
                        label="Senha atual"
                        margin="normal"
                        name="password"
                        // value={values.password}
                        onChange={handleChange}
                        type="password"
                        variant="outlined"
                    />
                    <TextField
                        fullWidth
                        label="Nova senha"
                        margin="normal"
                        name="confirm"
                        // value={values.confirm}
                        onChange={handleChange}
                        type="password"
                        variant="outlined"
                    />
                </CardContent>
                <Divider />
                <Box
                    display="flex"
                    justifyContent="flex-end"
                    p={2}
                >
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isLoading}
                    >
                        Alterar
                    </Button>

                </Box>
                {errorMessage && <Alert severity="warning">{errorMessage}</Alert>}
            </Card>
        </form>
    );
};

